export const ASSIGNED_TO = "Customer Portal Integration";
export const ASSIGNED_TO_EMAIL = "cfst@verizonconnect.com";
export const GOVT_ASSIGNED_TO_EMAIL = "reveal.govt@srv.verizonconnect.com";
export const ASSIGNED_EID = "VCCPCFST";
export const GOVT_ASSIGNED_EID = "VCCPGOVT";
export const MODIFIED_BY_EID = "VCCPCFST";
export const GOVT_MODIFIED_BY_EID = "VCCPGOVT";
export const RESCHEDULED = "Rescheduled";
export const RESCHEDULED_DATE_TIME = "Rescheduled Appointment Date and Time :";
export const APPOINTMENT_NUMBER = "Appointment number :";
export const DEVICE_NOT_REPORTED = "It looks like this tracker has not been fully installed yet. Select a different vehicle or powered asset, or";
export const NON_POWERED_ASSET_DETECTED =
  "It looks like this tracker is a non-powered asset. Our technicians only provide installation services for vehicles and powered assets. You can find step-by-step installation guides for non-powered assets in our";
export const CONTACT_SUPPORT = "contact Support.";
export const HELP_CENTER = "help center.";
export const EVC_DETECTED =
  "It looks like this vehicle has an extended view camera installed. To book a technician appointment for this vehicle, call us on (844) 617-1100, option 5. To book an appointment for other vehicles without extended view cameras, select a different vehicle or powered asset above.";
export const EVC_DETECTED_GOVT =
  "It looks like this vehicle has an extended view camera installed. To book a technician appointment for this vehicle, call us on (800) 906-9545. To book an appointment for other vehicles without extended view cameras, select a different vehicle or powered asset above.";
export const OEM_DETECTED =
  "It looks like the vehicle you've selected has built-in telematics. To book a technician appointment for this vehicle, call us on (844) 617-1100, option 5. To book an appointment for other vehicles without built-in telematics, select a different vehicle or powered asset above.";
export const OEM_DETECTED_GOVT =
  "It looks like the vehicle you've selected has built-in telematics. To book a technician appointment for this vehicle, call us on (800) 906-9545. To book an appointment for other vehicles without built-in telematics, select a different vehicle or powered asset above.";
export const DUPLICATE_VEHICLE_ASSET_DETECTED =
  "It looks like you have already created a service request for this vehicle or powered asset. Select another.";
export const HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED = "We need to confirm compatibility, or ship additional hardware.";
export const NO_MATCHING_VTU = "We couldn’t verify tracker compatibility with your new vehicle. We may need to ship additional hardware.";

//Verbiage used in request submitted and Additional information required page
export const INFORMATION_SAVED = "The information you have entered has been saved.";
export const CONTACT_TO_BOOK_APPOINTMENT = "We will contact you within the next two business days to book your appointment.";
export const CONFIRMATION_TO_EMAIL = "Confirmation of this request will be sent to the nominated contact via email.";
export const TRACK_PROGRESS_IN_SUPPORT_CASES = "You can track the progress of this request in your support cases.";
export const CALL_US = "Alternatively, you can call us directly on (844) 617-1100, option 5.";
export const CALL_US_GOVT = "Alternatively, you can call us directly on (800) 906-9545.";
export const CONTACT_TO_DISCUSS_NEXT_STEP = "We will contact you within the next two business days to discuss next steps.";

export const WARNING_REASON_DISPLAY_MESSAGES = {
  HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  REVEAL_BOXNAME_AND_SL_BOXTYPE_DID_NOT_MATCH: HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  VTU_PARTS_DID_NOT_MATCH: HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  CABLES_DID_NOT_MATCH: HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  DEVICE_TYPE_DID_NOT_MATCH: HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  FEATURES_NOT_COMPATIBLE: HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  NO_MATCHING_OLD_VIN_DEVICE_DETAILS: HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  OLD_VIN_NOT_FOUND: HARDWARE_NOT_COMPATIBLE_OR_NOT_SHIPPED,
  NEW_VIN_NOT_FOUND: NO_MATCHING_VTU,
  NO_RECOMMENDATIONS_FOUND: NO_MATCHING_VTU,
  NO_MATCHING_VTU,
};
export const DEFAULT_REASON = {
  reason: "Other",
  reasonName: "Other",
  rescheduleReasonCode: "OTH",
};

export const SUPPORT_PHONE_NUMBERS = {
  GOVERNMENT: "(800) 906-9545",
  COMMERCIAL: "(844) 617-1100 and select option 5",
};

export const DE_RE_VENDOR_QUE_ID = "00G0e000003C5BHEA0";
export const GOVT_REVEAL_SUPPORT_QUE_ID = "00G0e000003f4zHEAQ";
export const CUSTOMER_PORTAL_INTEGRATION_USER_ID = "0057V000008RqwcQAC";
